import { render } from "./ContractCarousel.vue?vue&type=template&id=35fef606"
import script from "./ContractCarousel.vue?vue&type=script&lang=js"
export * from "./ContractCarousel.vue?vue&type=script&lang=js"

import "./ContractCarousel.vue?vue&type=style&index=0&id=35fef606&lang=css"

import exportComponent from "/usr/src/app/vue-goparity/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__